import type { ReactNode } from 'react';

export type BadgeTone =
  | 'neutral'
  | 'info'
  | 'success'
  | 'warning'
  | 'danger'
  | 'gold';

const TONE_PALETTE: Record<BadgeTone, { bg: string; text: string }> = {
  neutral: { bg: '#E5E7EB', text: '#374151' },
  info:    { bg: '#DBEAFE', text: '#1D4ED8' },
  success: { bg: '#D1FAE5', text: '#065F46' },
  warning: { bg: '#FEF3C7', text: '#92400E' },
  danger:  { bg: '#FEE2E2', text: '#B91C1C' },
  gold:    { bg: '#FEF3C7', text: '#92400E' },
};

interface Props {
  tone: BadgeTone;
  children: ReactNode;
  className?: string;
}

/**
 * Pill-shaped status indicator. Single source of truth for
 * badge tones across the app — every "is_active / inactive / role /
 * status / past / cancelled" pill should consume one of the canonical
 * tones below instead of inventing colour pairs inline.
 */
const StatusBadge = ({ tone, children, className }: Props): JSX.Element => {
  const palette = TONE_PALETTE[tone];
  return (
    <span
      className={`px-2 py-0.5 rounded-full text-xs font-semibold ${className ?? ''}`}
      style={{ background: palette.bg, color: palette.text }}
    >
      {children}
    </span>
  );
};

export default StatusBadge;
